import ApiService from './../api/ApiService';
import * as Config from '../constants/Config';
import Urls from './../api/Urls';
import Rating, { RatingReply } from './../models/Rating';
import { getDummyData } from './../utils/commonUtils';
import { random } from 'lodash';

export function getRatings(params) {
    return new ApiService({
        baseURL: Config.default.API_CONTENT,
        endpoint: Urls.RATING_LIST,
        params: params,
        parser: data => ratingsDataParser(data, params),
    }).get();
}

export function approveRating(rating) {
    return new ApiService({
        baseURL: Config.default.API_CONTENT,
        endpoint: Urls.RATING_APPROVE,
    }).put({ id: rating.id, isApproved: !rating.isApproved });
}

export function deleteRating(rating) {
    return new ApiService({
        baseURL: Config.default.API_CONTENT,
        endpoint: Urls.RATING_DELETE,
        params: { id: rating.id },
    }).delete();
}

export function approveRatingReply(reply) {
    return new ApiService({
        baseURL: Config.default.API_CONTENT,
        endpoint: Urls.RATING_REPLY_APPROVE,
    }).put({ id: reply.id, isApproved: !reply.isApproved });
}

export function deleteRatingReply(reply) {
    return new ApiService({
        baseURL: Config.default.API_CONTENT,
        endpoint: Urls.RATING_REPLY_DELETE,
        params: { id: reply.id },
    }).delete();
}

const ratingsDataParser = (data, params) => ({
    ratings: (data.data.result || []).map(item => new Rating(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount,
    orderBy: params.orderBy,
    orderByDesc: params.orderByDesc,
});

